import { DEFAULT_MY_LOCATION_KEYWORD } from '@/hooks/search/useSearch.constants';
import { TabIdentifier } from '../MegaMenu.constants';
import { TabIdentifier as Identifier } from '../MegaMenu.types';

export function getDefaultSEOContentCtaLink(identifier: Identifier) {
  switch (identifier) {
    case TabIdentifier.Hairdresser:
      return `/${encodeURIComponent('Frisör')}/${encodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Massage:
      return `/${encodeURIComponent('Massage')}/${encodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Nails:
      return `/${encodeURIComponent('Naglar')}/${encodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Lashes:
      return `/${encodeURIComponent('Fransar')}/${encodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Skincare:
      return `/${encodeURIComponent('Hudvård')}/${encodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Beauty:
      return `/${encodeURIComponent('Skönhet')}/${encodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Health:
      return `/${encodeURIComponent('Hälsa')}/${encodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;

    default:
      return '/';
  }
}
